module.exports = __webpack_public_path__ + "img/aquassist_logo_mini.0ee7ff67.png";